<div
  [ngClass]="containerClass"
  role="alert"
  [ngStyle]="styleObject"
  [attr.style]="styleString"
  [attr.aria-atomic]="true"
  [attr.aria-live]="'assertive'"
  >
  @if (contentTemplate) {
    <div [ngClass]="contentSeverityClass" role="alert">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  }
</div>

